import React, { useEffect, useState, FC } from "react";
import Loader from "./loader";
import { getOfficialRating } from "../actions";
import withRedux from "../withRedux";
import { _ } from "libs";
import { es } from "date-fns/esm/locale";

type Props = {
	federation: string;
	federationName: string;
	userId: string;
	onClose;
};

const OfficialRatingProfile: FC<Props> = ({ federation, userId, federationName, onClose }: Props) => {
	const [rating, setRating] = useState(null as any);

	useEffect(() => {
		getOfficialRating(userId, federation).then((rating) => {
			setRating(rating);
		});
	}, [userId, federation]);

	if (!rating) {
		return <Loader />;
	}

	const sections: Array<any> = rating.sections.sort(sortSections);

	return (
		<>
			<div className="bubble blue">
				<div className="header">
					<div className="icon verified" />
					<div className="title">Verified</div>
				</div>
				<div className="content">
					<p>{_("player.officialRating.verified", null, { federationName: federationName })}</p>
				</div>
			</div>
			{sections.map((section, i) => {
				return (
					<div className="section" key={"s" + i}>
						<div className="tableHeader">{section.label}</div>
						<div className="table">
							{section.content.map((content, j) => {
								if (!content.value && content.link) {
									return (
										<a
											className="tableRow disclosureIndicator"
											href={content.link}
											target="_blank"
											rel="noopener noreferrer"
											key={"s" + i + "c" + j}
										>
											<div className="tableRowLabel dark">{content.key}</div>
										</a>
									);
								} else if (content.value && !content.link) {
									return (
										<div className="tableRow" key={"s" + i + "c" + j}>
											<div className="tableRowLabel dark">{content.key}</div>
											<div className="tableRowValue">{content.value}</div>
										</div>
									);
								} else {
									return null;
								}
							})}
						</div>
					</div>
				);
			})}
			<p className="tableNote">{_("player.officialRating." + federation + ".footer")}</p>
		</>
	);
};

export default withRedux({}, () => {
	return {};
})(OfficialRatingProfile);

function sortSections(s1, s2) {
	if (s1.order < s2.order) {
		return -1;
	}
	if (s1.order > s2.order) {
		return 1;
	}
	return 0;
}
